import * as React from 'react'
import { PermissionCheckProps } from '../types'
import {
  PrimaryButton,
} from '@paytrace/pt-skel/Component'
import { hasPermission } from '../Helper/HasPermission'

export const ProcessButton = (props: PermissionCheckProps) => {
  if (!hasPermission(props)) {
    return <React.Fragment />
  }
  return (
    <PrimaryButton className='uid-process form-btn'>
      <b>&#10003;</b> Process
    </PrimaryButton>
  )
}

export default ProcessButton
